import { render, staticRenderFns } from "./vote.vue?vue&type=template&id=c5308714&scoped=true&"
import script from "./vote.vue?vue&type=script&lang=js&"
export * from "./vote.vue?vue&type=script&lang=js&"
import style0 from "./vote.vue?vue&type=style&index=0&id=c5308714&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5308714",
  null
  
)

export default component.exports